import React from 'react';
import Header from './Component/Header';
import Footer from './Component/Footer';
import PageHero from './Component/PageHero';
import brand1 from './Component/f7.png';

function Financing() {
  return (
    <div className="min-h-screen bg-[#f7f8fa] text-slate-900 antialiased">
      <Header />
      <PageHero
        eyebrow="Make it possible"
        title="Financing"
        subtitle="Call us or stop in today to explore all of our available financing options"
      />

      <section className="pb-16 md:pb-24">
        <div className="mx-auto max-w-4xl px-4 text-center sm:px-6">
          <a
            href="https://www.synchrony.com/financing/home/partners?intcmp=na-homenetwork_cardholder-footer-data_reason-internal&uniqueId=A4A3EBF64AFDCFFC2134A5FA83B439C36152B7CA3C2EDF51&client=SynchronyHOME"
            target="_blank"
            rel="noreferrer"
            className="block overflow-hidden rounded-[1.75rem] bg-white p-4 shadow-sm ring-1 ring-slate-200/80 sm:p-8"
          >
            <img
              src={brand1}
              alt="Synchrony financing"
              className="mx-auto max-h-72 w-full object-contain"
            />
          </a>
          <p className="mx-auto mt-6 max-w-xl text-sm text-slate-500 sm:text-base">
            Flexible payment options through our trusted lending partners. Our team can help you
            find a plan that fits your project.
          </p>
          <a
            href="/contact"
            className="mt-6 inline-flex items-center justify-center rounded-full bg-[#0075ca] px-6 py-3 text-sm font-semibold text-white no-underline transition hover:bg-[#0063ad] sm:text-base"
          >
            Contact us about financing
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Financing;
